export function TelephoneLink(selector) {
    document.addEventListener('click', (e) => {
        if (window.innerWidth <= 768) {
            return;
        }

        const target = e.target.closest(selector);
        if (!target) {
            return;
        }

        e.preventDefault();
        navigator.clipboard.writeText(target.getAttribute('href').replace('tel:', ''));
        target.classList.add('telephone-link--has-copied');
        setTimeout(() => {
            target.classList.remove('telephone-link--has-copied');
        }, 1000);
    });
}

TelephoneLink('.telephone-link');
